module.exports = __webpack_public_path__ + "img/anniston-fire-logo.7fad61b6.jpg";